export class OfferStatusHistoryModel {
    public remoteId: number;
    public userId: number;
    public date: string;
    public user: string;
    public statusId: number;
}